import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import {
  MarketActivityIndicator,
  MarketInputText,
  MarketList,
  MarketPopover,
  MarketRow,
} from '@market/react';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import debounce from 'lodash/debounce';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const AddressSuggestions = (props) => {
  const { t } = useTranslation();
  const { addressClient } = useCheckoutFlow();

  const [searching, setSearching] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const { handleSuggestionSelected, addressType } = props;

  const fetchAutocompleteCandidates = useMemo(
    () =>
      debounce((partialAddress, callback) => {
        addressClient
          .autocompleteCandidates(partialAddress)
          .then((data) => callback(data))
          .catch(() => callback())
          .finally(() => setSearching(false));
      }, 500),
    [],
  );

  useEffect(() => {
    let active = true;

    if (searchInput === '') {
      setSuggestions([]);
      return undefined;
    }

    if (searchInput.length > 3) {
      setSearching(true);
      fetchAutocompleteCandidates(searchInput, (data) => {
        if (active && data) {
          setSuggestions(data.candidates || []);
        }
      });
    }

    return () => {
      active = false;
    };
  }, [searchInput, fetchAutocompleteCandidates]);

  return (
    <Grid item xs={12} md={12} data-dd-privacy={DATADOG_PRIVACY_LEVELS.HIDDEN}>
      <MarketInputText
        name="address_suggestions"
        onMarketInputValueChange={(e) => setSearchInput(e.detail.value)}
      >
        <label>{t('checkout.label.address')}</label>
      </MarketInputText>
      {searchInput.length > 0 && (
        <MarketPopover style={{ marginTop: '2px', width: '100%' }}>
          <MarketList
            onMarketListSelectionsDidChange={(e) =>
              handleSuggestionSelected(
                e.detail.newSelectionValue,
                searchInput,
                addressType,
              )
            }
          >
            <MarketRow value="user-input">
              {searchInput}
              {searching && (
                <MarketActivityIndicator size="small" slot="side-label" />
              )}
            </MarketRow>
            {suggestions.map((s) => (
              <MarketRow key={s.place_id} value={s.place_id}>
                {s.combined_address}
              </MarketRow>
            ))}
          </MarketList>
        </MarketPopover>
      )}
    </Grid>
  );
};

export default AddressSuggestions;
